var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('div', {
    staticClass: "border border-solid border-primary px-5 py-16 sm-md:py-5",
    attrs: {
      "id": "AddressVerificationModal"
    }
  }, [_c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('h2', [_vm._v("Did you mean this?")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\tWe found a more precise version of the address you entered. If it looks right, please\n\t\t\t\tselect the suggested address.\n\t\t\t")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "AddressSuggested"
    }
  }, [_c('h3', [_vm._v("Suggested Address:")]), _vm._v(" "), _vm._l(_vm.suggestion, function (suggest, x) {
    return _c('div', {
      key: x,
      staticClass: "address-option address-active",
      on: {
        "click": function ($event) {
          return _vm.selectSuggestion(suggest);
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.picked,
        expression: "picked"
      }],
      attrs: {
        "id": suggest.deliveryLine1,
        "name": suggest.deliveryLine1,
        "type": "radio"
      },
      domProps: {
        "value": suggest.deliveryLine1,
        "checked": _vm._q(_vm.picked, suggest.deliveryLine1)
      },
      on: {
        "change": function ($event) {
          _vm.picked = suggest.deliveryLine1;
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "address-full",
      attrs: {
        "for": suggest.deliveryLine1
      }
    }, [_vm._v(_vm._s(_vm.formatAddress(suggest.deliveryLine1, suggest.deliveryLine2, suggest.components.cityName, suggest.components.state, suggest.components.zipCode)))])]);
  })], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "AddressOriginal"
    }
  }, [_c('h3', [_vm._v("Original Address:")]), _vm._v(" "), _c('div', {
    staticClass: "address-option address-active",
    on: {
      "click": function ($event) {
        return _vm.selectOriginalAddress();
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.picked,
      expression: "picked"
    }],
    attrs: {
      "id": "originalAddress.street_one",
      "name": "originalAddress.street_one",
      "value": "originalAddress.street_one",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.picked, "originalAddress.street_one")
    },
    on: {
      "change": function ($event) {
        _vm.picked = "originalAddress.street_one";
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "address-full",
    attrs: {
      "for": "originalAddress.street_one"
    }
  }, [_vm._v(_vm._s(_vm.originalAddressFull))])])]), _vm._v(" "), _c('button', {
    staticClass: "button--filled mt-12 sm:w-full",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableSubmit
    }
  }, [_vm._v("\n\t\t\t\tUpdate Address\n\t\t\t")]), _vm._v(" "), _vm.confirmation ? _c('h3', {
    staticClass: "warningAlert"
  }, [_vm._v("Please make sure this address is correct!")]) : _vm._e()])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };